import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';
import {
  deleteAdminV1StoresStoreIdRedirectsId,
  getAdminV1StoresStoreIdRedirects,
  patchAdminV1StoresStoreIdRedirectsId,
  postAdminV1StoresStoreIdRedirects,
  type GetAdminV1StoresStoreIdRedirects200,
  type PatchAdminV1StoresStoreIdRedirectsIdBody,
  type PostAdminV1StoresStoreIdRedirectsBody,
  type Redirect,
} from '@nucleus-commerce/api-client/admin';

/**
 * List params as `listParams` builds them from the route's search: `q`, `sort`, the flat filter
 * params (`statusCode=301`, `hits_gte=10`, `lastHitAt_gte=2026-09-01`), `cursor`, `limit`.
 */
export type RedirectListParams = ListParams;

/** URL redirects of one store; handle renames add rows here on their own. */
export const redirectsApi = {
  list: (
    storeId: string,
    params: RedirectListParams,
  ): Promise<GetAdminV1StoresStoreIdRedirects200> =>
    getAdminV1StoresStoreIdRedirects({ storeId }, params),
  create: (storeId: string, body: PostAdminV1StoresStoreIdRedirectsBody): Promise<Redirect> =>
    postAdminV1StoresStoreIdRedirects({ storeId }, body),
  update: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdRedirectsIdBody,
  ): Promise<Redirect> => patchAdminV1StoresStoreIdRedirectsId({ storeId, id }, body),
  remove: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdRedirectsId({ storeId, id }),
};
